import {useEffect, useRef, useState, useContext} from "react";
import useCanvas from "./useCanvas";
import {initDevice} from "../../../../../utils";
import {createElementImage} from "../../../../../utils";
import {EVENT_TRACER, keyswordsBack, keyswordsFront} from "../../../../../constants";
import {Stream} from "../../../utils/helpers/Stream";
import {documentValidator} from "../../../../../services/documentValidator";
import { cropImageFromGuide, base64ToBlob, createImageFromBase64, drawImageOnCanvas, createCanvas, createBase64 } from "../../../utils/canvas";
import {ConfigContext} from "../../../../../context/ConfigContext";
import { startCamera, isMovil, onReportEvent, responseToHost, updateBorder, stopCamera } from "../../../utils";

let worker
let TIME_TO_CAPTURE_MANUAL = 20
let TIME_TO_CHANGE_MESSAGE_ERROR = 2000

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

let timer
export default function useCamera({containerRef, guideAdo, textPreview, closeIcon, takePhoto, videoRef, canvasRef}) {

    const { value: configValue, loading: configLoading } = useContext(ConfigContext);
    const {getFaces} = useCanvas(showStep)
    const [loading, setLoading] = useState(true)
    const [cameraIsReady, setCameraIsReady] = useState(false);
    const [isImageValidate, setImageValidate] = useState(false)
    const [typeCapture, setTypeCapture] = useState('')
    const [ocr, setOcr] = useState('')
    const videoInitRef = useRef(null);
    const finished = useRef(null);
    const initProcess = useRef(null);
    const canvasPreviewRef = useRef(null);
    const canvasCroppedImageRef = useRef(null);
    const timerRef = useRef(0);
    const markRef = useRef(null);
    const manualPhotoTaken = useRef(false);
    const [capturedImageBack, setCapturedImageBack] = useState(null);
    const [step, setStep] = useState('');
    const [indicatorRotate, setIndicatorRotate] = useState(true);
    const [stepHistory, setStepHistory] = useState([]);
    const [seconds, setSeconds] = useState(0);
    const captured = useRef(false);
    const [textPreviewMessage, setTextPreviewMessage] = useState('')

    // GET URL PARAMS
    const isFront = params.isFront || 'true'
    const debug = params.debug || 'false'
    const projectName = params.projectName || 'default'
    const platform = params.platform || 'web'
    const documentType = params.documentType
    const processId = params.processId
    const urlTracer = params.urlTracer
    const emitReadyCam = params.emitReadyCam || 'false'

    function createBase64() {
        const video = videoRef.current;
        if (!video) {
            throw new Error('Video is not available');
        }
        const { videoWidth: width, videoHeight: height } = video;
    
        const originalCanvas = createCanvas(width, height);
        drawImageOnCanvas(originalCanvas, video);   
    
        return originalCanvas.toDataURL('image/jpeg');
    }

    function reportError(message) {
        const isSuccess = Array.from(containerRef.current.classList).includes('success')
        const isDanger = Array.from(containerRef.current.classList).includes('danger')
        if (isSuccess) {
            containerRef.current.classList.replace('success', 'danger')
        } else if(!isDanger && !isSuccess){
            containerRef.current.classList.add('danger')
        }
        textPreview.current.innerText = message
    }
    
    async function callbackAutoCapturing(result) {
        if (captured.current) return
        if (documentType && !result.documentMatch) {
            reportError(configValue.messages.messageNoMatchId)
            return
        }
        updateBorder(configValue.styles.successColor, guideAdo, videoRef)
        captured.current = true;
        const streamProperties = {
            device: initDevice(),
            modelPath: '/models',
            croppedImage: true,
            urlService: configValue.urlService,
            isFront,
            documentType,
            processId
        }
        const streamRef = Stream.getInstance(streamProperties)
        streamRef.dropStream()
        const image = await createImageFromBase64(result.image);
        const imageResized = cropImageFromGuide(videoRef.current, guideAdo.current)
        setTimeout(() => {
            containerRef.current.classList.replace('display-elements', 'hide-elements');
            takePhoto.current.classList.add('hide')
            responseToHost(1, image, imageResized, result.documentName, timer,
                showStep, finished, videoRef, guideAdo, textPreview
            )
        }, 1000)
    }
    function initTimer() {
        timer = setInterval(() => {
            timerRef.current = timerRef.current + 1
            setSeconds(prevState => prevState + 1)
        }, 1000);
    }
    async function startCameraDesktop(currentTypeCapture) {
        const constraintsDesktop = {
            video: true
        };
        videoRef.current.srcObject = await navigator.mediaDevices.getUserMedia(constraintsDesktop);

        await captureImage(currentTypeCapture)
    }
    function showMessageTimeout () {
        const message = typeCapture === '1'
        ? (configValue?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto')
        : (configValue?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto')
        setTextPreviewMessage(message)
    }

    async function takeManualPhoto() {
    await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureInitCaptureManual, 'Ha entrado en captura manual', urlTracer, processId);
    if (manualPhotoTaken.current) return;
    manualPhotoTaken.current = true;

    try {
        setLoading(true);
        const imageResized = cropImageFromGuide(videoRef.current, guideAdo.current)
        containerRef.current.classList.replace('display-elements', 'hide-elements');
        takePhoto.current.classList.add('hide');
        const imageRotated = createBase64(videoRef);
        const imageResizedBlob = await base64ToBlob(imageRotated)
        const response = await documentValidator({base64Data: imageResizedBlob, urlService: configValue.urlService, isFront, documentType, processId});
        setLoading(false);

        // If document type is not the expected
        if (documentType && !response.data.documentTypeMatch) {
            reportError(configValue.messages.messageNoMatchId)
            containerRef.current.classList.replace('hide-elements', 'display-elements');
            takePhoto.current.classList.remove('hide');
            manualPhotoTaken.current = false;
            return
        }
        

        if (response.data.quality) {
            await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureTakePhoToManual, 'El usuario a tomado una foto manual', urlTracer, processId);
            responseToHost(isFront === 'true' ? 1 : 2, imageRotated, imageResized, '', timer,
            showStep, finished, videoRef, guideAdo, textPreview);
        } else {
            reportError(configValue.messages.messageCroppedId);
            containerRef.current.classList.replace('hide-elements', 'display-elements');
            takePhoto.current.classList.remove('hide');
            manualPhotoTaken.current = false;
        }
    } catch (e) {
        console.error('takeManualPhoto error', e);
        responseToHostError(isFront === 'true' ? 'Frontal' : 'Trasera', e.message);
    }
}

    function showStep(message, show= true) {
        if (show) {
            setStepHistory(prevState => [...prevState, message])
            setStep(message)
        }
    }

    async function captureImage(type) {
        showStep(`Capture image ${type}`)
        const video = videoRef.current;
        const canvas = canvasRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        // canvas.width = 20;
        // canvas.height = 20;

        drawImageOnCanvas(canvas, video)
        // const context = canvas.getContext('2d');
        // context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const capturedDataUrl = canvas.toDataURL('image/jpeg');
        showStep('Image to data url')
        const imgElement = await createElementImage(capturedDataUrl);

        const imagebase64 = capturedDataUrl

        if (type === 1) {

            let imageToResponse = imagebase64
            setTimeout(async () => {
                const hasFaces = await getFaces(imgElement)
                if (!hasFaces.haarFace) {
                    setImageValidate(false)
                    imgElement.remove()
                    showStep('captureImage 1', true)
                    await captureImage(1)
                    return
                }
                setImageValidate(true)
                setCameraIsReady(false)
                const isOcr = await validateOCR(imagebase64, keyswordsFront);
                if (!isOcr) {
                    // setOcr('No')
                    await captureImage(1)
                    return
                }
                setOcr('Si')
                console.log('captureImage')
                responseToHost(type, imageToResponse, imageToResponse, '', timer,
                    showStep, finished, videoRef, guideAdo, textPreview)
            }, 200)
        } else {
            setTimeout(async () => {
                const isOcr = await validateOCR(imagebase64, keyswordsBack);
                if (!isOcr) {
                    setOcr('No')
                    await captureImage(2)
                    return
                }
                setOcr('Si')
                setCameraIsReady(false)
                responseToHost(type, imagebase64, imagebase64, '', timer,
                    showStep, finished, videoRef, guideAdo, textPreview)
            }, 200)
        }
    }

    function checkKeywords(text, keywords) {
        const words = keywords.toLowerCase().split(' ');
        const lowerText = text.replace(/[^a-zA-Z0-9-\s]/g, "").toLowerCase();
        for (const word of words) {
            if (lowerText.includes(word)) {
                return true;
            }
        }
        return false;
    }

    function responseToHostError(type, message) {
        finished.current = true

        if (videoRef.current) {
            videoRef.current.style.display = 'none'
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none'
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none'
        }
        stopCamera(videoRef)
        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, message, urlTracer, processId).catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }));
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }),
            '*'
        );
    }
    async function validateOCR(image, keywords, type, imgElement) {
        return new Promise(async (resolve, reject) => {
            showStep('Init validate OCR')
            try {
                const { data: { text } } = await worker.recognize(image);
                setOcr(text)

                const includesKeyword = checkKeywords(text, keywords);
                resolve(includesKeyword)

            } catch (error) {
                // showStep(`Error -> ${error.message}`)
                console.log('error isCard', error)
                reject(error)

            }
        })
    }

    function goBack() {
        setOcr('clicked back')
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.FinishClose.goBack();
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }),
            '*'
        );
    }

    function generateFilterValue(hexColor) {
        // Verificar si el valor hexadecimal es válido
        if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hexColor)) {
            throw new Error('Valor hexadecimal no válido.');
        }

        // Remover el signo '#' si está presente
        hexColor = hexColor.replace('#', '');

        // Separar el valor en componentes (rojo, verde, azul)
        let r, g, b;

        if (hexColor.length === 3) {
            r = parseInt(hexColor[0] + hexColor[0], 16);
            g = parseInt(hexColor[1] + hexColor[1], 16);
            b = parseInt(hexColor[2] + hexColor[2], 16);
        } else {
            r = parseInt(hexColor.slice(0, 2), 16);
            g = parseInt(hexColor.slice(2, 4), 16);
            b = parseInt(hexColor.slice(4, 6), 16);
        }

        // Calcular los valores de filtro
        const invertValue = `${100 - (r / 255 * 100)}%`;
        const sepiaValue = `${(g / 255 * 100)}%`;
        const saturateValue = `${r / 255 * 6000}%`;
        const hueRotateValue = `${(g / 255 * 360)}deg`;
        const brightnessValue = `${(b / 255 * 200)}%`;
        const contrastValue = `${(g / 255 * 200)}%`;

        // Construir la cadena de filtro
        const filterValue = `invert(${invertValue}) sepia(${sepiaValue}) saturate(${saturateValue}) hue-rotate(${hueRotateValue}) brightness(${brightnessValue}) contrast(${contrastValue})`;

        return filterValue;
    }
    function hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b) => {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? [
                parseInt(result[1], 16),
                parseInt(result[2], 16),
                parseInt(result[3], 16),
            ]
            : null;
    }

    // Update the text preview based on the configCardCapture
    function updateTextPreview(messages, typeCapture) {
        if (messages) {
            const { messageFront, messageBack } = messages;
            const text = typeCapture === '1' ? messageFront : messageBack;
            setTextPreviewMessage(text)
        }
    }
    
    // Update the close icon based on the configCardCapture
    function updateCloseIcon(iconClose) {
        
        if (iconClose && closeIcon.current) {
            const { url, size, color, show } = iconClose;
            const iconSize = size || '30px';
            
            if (url && isMovil() && show) {
                closeIcon.current.innerHTML = `<img alt="img-back" style="width: 100%" src="${url}"/>`;
                closeIcon.current.style.cssText = `height: ${iconSize}px; width: ${iconSize}px;`;
            } else {
                closeIcon.current.innerText = "X";
                closeIcon.current.style.cssText = `font-size: ${iconSize}px; color: ${color || 'white'};`;
            }
        }
    }

    function responseToHostReadyCam() {

        if (emitReadyCam === 'true') {

            const message = 'ado-cam-ready'

            if (platform === 'ios') {
                window.webkit.messageHandlers.messageHandlersName.postMessage(message);
                return;
            }
    
            if (platform === 'android') {
                window.ResponseAdo.handleEvent(message);
                return
            }
    
            if (platform === 'react-native') {
                window.ReactNativeWebView.postMessage(message)
                return
            }
            window.parent.postMessage(
                message,
                '*'
            );
        }

    }
    
    async function setConfigValues() {
        if (Object.keys(configValue).length > 0) {
            TIME_TO_CAPTURE_MANUAL = configValue.timeout;
            updateTextPreview(configValue.messages, isFront === "true" ? '1' : '2');
            updateCloseIcon(configValue.closeIcon);
        }
    }

    function showGuide() {
        containerRef.current.classList.replace('hide-elements', 'display-elements');
    }

    useEffect(() => {
        if (projectName && !isMovil() && !configLoading) {
            setConfigValues()
        }
    }, [projectName, configLoading])

    useEffect(() => {
        if (!initProcess.current) {
            initProcess.current = true
            if (isFront === 'true' || isFront === 'true/') {
                setTypeCapture('1')
                isMovil() 
                ? startCamera(
                    1,
                    videoRef,
                    canvasRef,
                    containerRef,
                    Stream,
                    configValue,
                    callbackAutoCapturing,
                    onManualCapture,
                    setConfigValues,
                    initTimer,
                    setLoading,
                    responseToHostError,
                    showGuide).catch() 
                : startCameraDesktop(1).catch()
            } else {
                setTypeCapture('2')
                isMovil() 
                ? startCamera(
                    2,
                    videoRef,
                    canvasRef,
                    containerRef,
                    Stream,
                    configValue,
                    callbackAutoCapturing,
                    onManualCapture,
                    setConfigValues,
                    initTimer,
                    setLoading,
                    responseToHostError,
                    showGuide).catch() 
                : startCameraDesktop(2).catch()
            }
        }
    }, [])  


    // Si el tiempo de captura automática se cumple y no se ha capturado manualmente, se muestra el botón de captura manual
    const onManualCapture = useRef(false);
    if (timerRef.current === TIME_TO_CAPTURE_MANUAL && isMovil() && !onManualCapture.current) {
        const streamProperties = {
            device: initDevice(),
            modelPath: '/models',
            croppedImage: true,
            urlService: configValue.urlService,
            isFront,
            documentType,
            processId
        }
        const streamRef = Stream.getInstance(streamProperties)
        streamRef.dropStream()
        containerRef.current.classList.remove('danger')
        takePhoto.current.classList.remove('hide')
        onManualCapture.current = true
        showMessageTimeout()
        
        clearInterval(timer)
    }

    return {
        capturedImageBack,
        cameraIsReady,
        canvasPreviewRef,
        indicatorRotate,
        isImageValidate,
        canvasCroppedImageRef,
        ocr,
        debug,
        step,
        stepHistory,
        typeCapture,
        markRef,
        loading,
        projectName,
        isMovil,
        goBack,
        takeManualPhoto,
        textPreviewMessage,
        emitReadyCam
    }
}
